import api from './client';

export interface TrialChannelAvailability {
  available: boolean;
  /** Present when `available` is false, e.g. "Available on paid plans". */
  reason?: string;
}

/** GET /onboarding/trial while the organization is on a free trial. */
export interface ActiveTrialStatus {
  isTrial: true;
  onboardingStatus: string;
  expired: boolean;
  trialEndsAt: string;
  daysLeft: number;
  emailVerified: boolean;
  needsPassword?: boolean;
  channels: Record<'WEB_WIDGET' | 'WHATSAPP' | 'VOICE', TrialChannelAvailability>;
  agents: { used: number; max: number };
  /**
   * Counts every USER message across the organization's agents — widget
   * visitors included, not just the dashboard chat test.
   */
  messages: { used: number; max: number; remaining: number };
  /** False once expired, unverified, or out of messages. */
  canTest: boolean;
}

/** Organizations that were never on a trial (or have since activated). */
export interface NoTrialStatus {
  isTrial: false;
}

export type TrialStatus = ActiveTrialStatus | NoTrialStatus;

/** Owner-equivalent roles only on the backend — CUSTOMER passes as an owner. */
export const fetchTrialStatus = async (): Promise<TrialStatus> => {
  const { data } = await api.get<TrialStatus>('/onboarding/trial');
  return data;
};
